import React, { useEffect, useState } from "react";
import { Tabs, Tab, Button } from "react-bootstrap";
import { api_url } from "../../constant/constant";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import LcLesson from '../../Components/LcLessonModal/LcLesson';
import Userupdatepassword from "../../Components/UserUpdatePasswordModel/Userupdatepassword";
import ProfileDetail from "../../Components/ProfileModal/ProfileDetail";

const UserDetail = () => {
  const { id } = useParams(); // Ensure the route contains a parameter named 'id'

  const { t } = useTranslation();
  const [key, setKey] = useState("details");
  const navigate = useNavigate();

  // State variables
  const [data, setVideos] = useState([]);
  const [links, setLinks] = useState([]);
  const [deleted, setDeleted] = useState("");

  return (
    <div className="p-4 mb-4">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <div className="pageTitle">{t("UserDetail")}</div>
        <Button variant="primary" onClick={() => navigate(-1)}>
          {t("Back")}
        </Button>
      </div>

      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="details" title={t("ProfileDetail")}>
          <div>
            <ProfileDetail />
          </div>
        </Tab>

        <Tab eventKey="Password" title={t("Password")}>
          <div>
            <Userupdatepassword id={id} />
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default UserDetail;
